<div class="claimed-card" [class.my-card]="mode === 'mine'">
  <button *ngIf="mode === 'mine'" type="button" class="card-head" [disabled]="!canOpen()" (click)="openSection()"
          [attr.aria-expanded]="canOpen() ? expanded() : null">
    <span class="title-block">
      <span class="card-title">My Claimed Files</span>
      <span class="card-subtitle">Files currently claimed by you</span>
    </span>
    <span class="active-pill" *ngIf="activeCount() > 0">{{ activeCount() }} ACTIVE</span>
  </button>

  <div *ngIf="mode === 'all'" class="card-head team-head">
    <span class="title-block">
      <span class="card-title">Claimed Files</span>
      <span class="card-subtitle">Files currently being worked on by the team</span>
    </span>
    <span class="active-pill" *ngIf="activeCount() > 0">{{ activeCount() }} ACTIVE</span>
  </div>

  <div class="loading-state" *ngIf="isLoading()" aria-label="Loading claimed files">
    <div class="row-skel" *ngFor="let _ of [1, 2, 3]"></div>
  </div>

  <div class="empty-state" *ngIf="!isLoading() && !loadError() && activeCount() === 0">
    <i class="bi bi-inbox" aria-hidden="true"></i>
    <p>{{ mode === 'all' ? 'No claimed files' : 'You have no claimed files' }}</p>
  </div>

  <div class="error-state" *ngIf="!isLoading() && loadError()">
    <p>Claimed files could not be loaded.</p>
    <button type="button" (click)="loadClaimed()">Retry</button>
  </div>

  <div class="team-owners" *ngIf="mode === 'all' && owners().length > 0">
    <span class="owners-label">Claimed by user</span>
    <div class="team-user-list">
      <button type="button" class="user-row" *ngFor="let owner of owners(); let index = index"
              [class.selected]="selectedOwnerIndex() === index"
              [attr.aria-expanded]="selectedOwnerIndex() === index"
              aria-controls="team-owner-files" (click)="selectOwner(index)">
        <span class="user-icon" aria-hidden="true"><i class="bi bi-person-circle"></i></span>
        <span class="user-name">{{ owner.name }}</span>
        <span class="owner-count">{{ owner.count }} {{ owner.count === 1 ? 'file' : 'files' }}</span>
        <i class="bi" [ngClass]="selectedOwnerIndex() === index ? 'bi-chevron-up' : 'bi-chevron-down'" aria-hidden="true"></i>
      </button>
    </div>

    <div id="team-owner-files" class="team-owner-files" *ngIf="selectedOwner() as owner">
      <div class="team-files-heading">
        <span>{{ owner.name }} · {{ owner.count }} {{ owner.count === 1 ? 'file' : 'files' }}</span>
      </div>
      <div class="team-files-list">
        <button type="button" class="file-row" *ngFor="let file of owner.files; trackBy: trackFile"
                [disabled]="!canOpenFile()" (click)="openFile(file.pureOriginalId)">
          <span class="file-icon" aria-hidden="true"><i class="bi bi-file-earmark"></i></span>
          <span class="file-info">
            <span class="file-name">{{ file.fileName }}</span>
            <span class="file-meta" *ngIf="file.metadata">{{ file.metadata }}</span>
          </span>
          <span class="file-ago">{{ file.ago }}</span>
          <i class="bi bi-chevron-right file-chevron" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </div>

  <div class="files-list" *ngIf="mode === 'mine' && canOpen()" [class.expanded]="expanded()">
    <button type="button" class="file-row" *ngFor="let file of visibleFiles(); trackBy: trackFile"
            [disabled]="!canOpenFile()" (click)="openFile(file.pureOriginalId)">
      <span class="file-icon" aria-hidden="true"><i class="bi bi-file-earmark"></i></span>
      <span class="file-info">
        <span class="file-name">{{ file.fileName }}</span>
        <span class="file-meta" *ngIf="file.metadata">{{ file.metadata }}</span>
      </span>
      <span class="file-ago">{{ file.ago }}</span>
      <i class="bi bi-chevron-right file-chevron" aria-hidden="true"></i>
    </button>
  </div>

  <button type="button" class="section-action" *ngIf="mode === 'mine' && canOpen()" (click)="openSection()">
    {{ expanded() ? 'Show fewer files' : 'View all my claimed files' }}
    <i class="bi" [ngClass]="expanded() ? 'bi-chevron-up' : 'bi-arrow-right'" aria-hidden="true"></i>
  </button>
</div>
